import { MaterialHeaderRow } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { ProjectViews } from 'store/UI/UITypes'
import { bomItemSelector } from './bomItemSelector'

export const bomItemCuttingPlansSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(
      state,
      bomItemId,
      state.project.currentView === ProjectViews.AssemblyHierarchy
    )

    if (bomItem?.type === 'Row') {
      const headers = Object.values(state.project.flatView || {}).filter(
        (x) => x.type === 'MaterialHeader'
      ) as MaterialHeaderRow[]

      const cuttingPlans = headers.flatMap((x) =>
        x.cuttingPlans?.filter((plan) => plan.partTypeIds.includes(bomItemId))
      )

      return cuttingPlans
    }

    return null
  }
